export interface TicketAutomationSettings {
  enabled: boolean;
  staffReminderEnabled: boolean;
  staffPushEnabled: boolean;
  pendingReminderHours: number;
  onHoldCloseHours: number;
  responseHours: number;
  resolutionHours: number;
  staffSubject: string;
  staffBody: string;
  customerBody: string;
}

export const DEFAULT_TICKET_AUTOMATION: TicketAutomationSettings = {
  enabled: true,
  staffReminderEnabled: true,
  staffPushEnabled: true,
  pendingReminderHours: 48,
  onHoldCloseHours: 72,
  responseHours: 8,
  resolutionHours: 72,
  staffSubject: "[{{ticket.id}}] Response needed: {{ticket.subject}}",
  staffBody: "Hello,\n\nTicket {{ticket.id}} is assigned to you and is still waiting for a response. Half of the response SLA has elapsed.\n\n{{ticket.subject}}\n{{ticket.url}}\n\nPlease review the conversation and reply to the customer.",
  customerBody: "Hello {{ticket.requester.name}},\n\nWe are following up on your support request: {{ticket.subject}}. Do you still need assistance? Please reply to this message if you need more help.\n\nWe have put this ticket on hold. If we do not hear back within {{automation.close_hours}} hours, it will close automatically. After closure, please create a new ticket if you need more help. Replies by email after closure will create a new ticket.\n\nThank you,\n{{helpdesk_name}}",
};

export const AUTOMATION_SHORTCODES = ["ticket.id", "ticket.subject", "ticket.url", "ticket.requester.name", "ticket.requester.email", "helpdesk_name", "automation.close_hours"];

export function renderAutomationTemplate(template: string, values: Record<string, string>): string {
  return template.replace(/{{\s*([^{}]+?)\s*}}/g, (match, key: string) => values[key.trim()] ?? match);
}
